var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 5.83333H7.4974M12.4974 9.16667H7.4974M12.4974 12.5H9.16406M4.16406 2.5H15.8307V17.5L14.9707 16.7633C14.6687 16.5045 14.284 16.3622 13.8861 16.3622C13.4883 16.3622 13.1036 16.5045 12.8016 16.7633L11.9416 17.5L11.0824 16.7633C10.7803 16.5042 10.3954 16.3618 9.9974 16.3618C9.59939 16.3618 9.21452 16.5042 8.9124 16.7633L8.05323 17.5L7.19323 16.7633C6.89117 16.5045 6.50647 16.3622 6.10865 16.3622C5.71082 16.3622 5.32612 16.5045 5.02406 16.7633L4.16406 17.5V2.5Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 5.83333H7.4974M12.4974 9.16667H7.4974M12.4974 12.5H9.16406M4.16406 2.5H15.8307V17.5L14.9707 16.7633C14.6687 16.5045 14.284 16.3622 13.8861 16.3622C13.4883 16.3622 13.1036 16.5045 12.8016 16.7633L11.9416 17.5L11.0824 16.7633C10.7803 16.5042 10.3954 16.3618 9.9974 16.3618C9.59939 16.3618 9.21452 16.5042 8.9124 16.7633L8.05323 17.5L7.19323 16.7633C6.89117 16.5045 6.50647 16.3622 6.10865 16.3622C5.71082 16.3622 5.32612 16.5045 5.02406 16.7633L4.16406 17.5V2.5Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 5.83333H7.4974M12.4974 9.16667H7.4974M12.4974 12.5H9.16406M4.16406 2.5H15.8307V17.5L14.9707 16.7633C14.6687 16.5045 14.284 16.3622 13.8861 16.3622C13.4883 16.3622 13.1036 16.5045 12.8016 16.7633L11.9416 17.5L11.0824 16.7633C10.7803 16.5042 10.3954 16.3618 9.9974 16.3618C9.59939 16.3618 9.21452 16.5042 8.9124 16.7633L8.05323 17.5L7.19323 16.7633C6.89117 16.5045 6.50647 16.3622 6.10865 16.3622C5.71082 16.3622 5.32612 16.5045 5.02406 16.7633L4.16406 17.5V2.5Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 5.83333H7.4974M12.4974 9.16667H7.4974M12.4974 12.5H9.16406M4.16406 2.5H15.8307V17.5L14.9707 16.7633C14.6687 16.5045 14.284 16.3622 13.8861 16.3622C13.4883 16.3622 13.1036 16.5045 12.8016 16.7633L11.9416 17.5L11.0824 16.7633C10.7803 16.5042 10.3954 16.3618 9.9974 16.3618C9.59939 16.3618 9.21452 16.5042 8.9124 16.7633L8.05323 17.5L7.19323 16.7633C6.89117 16.5045 6.50647 16.3622 6.10865 16.3622C5.71082 16.3622 5.32612 16.5045 5.02406 16.7633L4.16406 17.5V2.5Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceLight);
export default __webpack_public_path__ + "static/media/invoice-light.aeefd9330ae47ae8ecc7d22b75a0f24a.svg";
export { ForwardRef as ReactComponent };